import client from '../../../apollo';
import { gql } from '@apollo/client'

export const BOTTOM_SURVEY_FETCH_FAIL = 'BOTTOM_SURVEY_FETCH_FAIL';
export const BOTTOM_SURVEY_FETCH_INIT = 'BOTTOM_SURVEY_FETCH_INIT';
export const BOTTOM_SURVEY_FETCH_SUCCESS = 'BOTTOM_SURVEY_FETCH_SUCCESS';
export const TOP_SURVEY_FETCH_FAIL = 'TOP_SURVEY_FETCH_FAIL';
export const TOP_SURVEY_FETCH_INIT = 'TOP_SURVEY_FETCH_INIT';
export const TOP_SURVEY_FETCH_SUCCESS = 'TOP_SURVEY_FETCH_SUCCESS';

const initialState = {
  bottomSurveys: [],
  bottomSurveysError: '',
  bottomSurveysLoading: false,
  bottomRetries: 0,
  topSurveys: [],
  topSurveysError: '',
  topSurveysLoading: false,
  topRetries: 0
};

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case BOTTOM_SURVEY_FETCH_FAIL:
      return {
        ...state,
        bottomSurveysError: action.error,
        bottomSurveysLoading: false,
        bottomRetries: state.bottomRetries + 1
      };
    case BOTTOM_SURVEY_FETCH_INIT:
      return {
        ...state,
        bottomSurveysLoading: true
      };
    case BOTTOM_SURVEY_FETCH_SUCCESS:
      return {
        ...state,
        bottomSurveys: action.data,
        bottomSurveysError: '',
        bottomSurveysLoading: false,
        bottomRetries: 0
      };
    case TOP_SURVEY_FETCH_FAIL: {
      return {
        ...state,
        topSurveysError: action.error,
        topSurveysLoading: false,
        topRetries: state.topRetries + 1
      };
    }
    case TOP_SURVEY_FETCH_INIT:
      return {
        ...state,
        topSurveysLoading: true
      };
    case TOP_SURVEY_FETCH_SUCCESS:
      return {
        ...state,
        topSurveys: action.data,
        topSurveysError: '',
        topSurveysLoading: false,
        topRetries: 0
      };
    default:
      return state;
  }
}

const topSurveyFetchQuery = gql`
  query topSurveys {
    topSurveys {
      id
      jobCount
      name
      utilization
    }
  }
`;

const bottomSurveyFetchQuery = gql`
  query bottomSurveys {
    bottomSurveys {
      id
      jobCount
      name
      utilization
    }
  }
`;

export const actions = {};

actions.getBottomSurveys = async function getBottomSurveys(dispatch) {
  dispatch({ type: BOTTOM_SURVEY_FETCH_INIT });
  try {
    const response = await client.query({
      query: bottomSurveyFetchQuery,
      fetchPolicy: 'network-only'
    });
    dispatch({
      type: BOTTOM_SURVEY_FETCH_SUCCESS,
      data: response.data.bottomSurveys
    });
  } catch (error) {
    dispatch({
      type: BOTTOM_SURVEY_FETCH_FAIL,
      error: error.message
    });
    console.log(error);
  }
};

actions.getTopSurveys = async function getTopSurveys(dispatch) {
  dispatch({ type: TOP_SURVEY_FETCH_INIT });
  try {
    const response = await client.query({
      query: topSurveyFetchQuery,
      fetchPolicy: 'network-only'
    });
    dispatch({
      type: TOP_SURVEY_FETCH_SUCCESS,
      data: response.data.topSurveys
    });
  } catch (error) {
    dispatch({
      type: TOP_SURVEY_FETCH_FAIL,
      error: error.message
    });
    console.log(error);
  }
};
